export default "__VITE_ASSET__Bj5CnTFh__"